module.exports = __webpack_public_path__ + "img/image19.0756b46d.jpeg";